<div class="modal-content">
  <div class="modal-header">
    <h4 style="max-width: 80% !important;"><strong> {{ modalDetails?.optInModalTitle }} </strong></h4>
  </div>
  <div class="modal-body our-form-background">
    <div class="container-fluid">
      <p-card>
        <ng-template pTemplate="header">
          <div [innerHTML]="modalDetails?.optInModalText"></div>
        </ng-template>
        <div class="row">
          <div class="col-12">
            <ul class="list-group">
              <li class="list-group-item " *ngFor="let companyOptInAcceptanceSummary of companyOptInAcceptanceSummaries; let index = index">
                <div class="row justify-content-between align-items-center " style="width: 100%; margin-right: 0; margin-left: 0;">
                  <div class="col-xl-7  col-lg-7 col-md-12 col-sm-12  col-12">
                    <div class="row align-items-center" style="width: 100%;" *ngIf="companyOptInAcceptanceSummary.optInUrl !== ''">
                      <fa-icon style="margin-right: 10px; cursor: pointer;" [icon]="companyOptInAcceptanceSummary.getIcon()" size="sm" (click)="goToLink(companyOptInAcceptanceSummary)" [ngClass]="companyOptInAcceptanceSummary.getVisitedClass()"></fa-icon>
                      <a class="custom-link-tag" [innerHTML]="companyOptInAcceptanceSummary?.optInDescription" (click)="goToLink(companyOptInAcceptanceSummary)" style="margin-bottom: 0" [ngClass]="companyOptInAcceptanceSummary.getVisitedClass()"> </a>
                    </div>
                    <div class="row align-items-center" style="width: 100%;" *ngIf="companyOptInAcceptanceSummary.optInUrl === ''">
                      <fa-icon style="margin-right: 10px; cursor: context-menu;" [icon]="companyOptInAcceptanceSummary.getIcon()" size="sm" class="optin-visited"></fa-icon>
                      <a class="custom-link-tag optin-visited" [innerHTML]="companyOptInAcceptanceSummary?.optInDescription" style="margin-bottom: 0;cursor: context-menu; "> </a>
                    </div>
                    <div class="row" style="width: 100%;">
                      <small style="color: red" *ngIf="!companyOptInAcceptanceSummary.isUrlVisited && companyOptInAcceptanceSummary.mustVisit && companyOptInAcceptanceSummary.showMustVisit">
                        {{mustVisitMessage}}
                      </small>
                    </div>
                    <div class="row" style="width: 100%;">
                      <small style="color: red" *ngIf="companyOptInAcceptanceSummary.showError">
                        {{companyOptInAcceptanceSummary?.errorText}}
                      </small>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12  " [ngClass]="companyOptInAcceptanceSummary.decision === null ? 'optin-not-visited' : 'optin-visited' " *ngIf="companyOptInAcceptanceSummary.decisionRequired">
                    <div class="row" style="width: 100%">
                      <div class="col justify-content-sm-center justify-content-md-center justify-content-xl-end justify-content-lg-end justify-content-center d-flex">
                        <label style="margin-bottom: 0;">{{companyOptInAcceptanceSummary?.decisionLabel}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12" [ngClass]="companyOptInAcceptanceSummary.decision === null ? 'optin-not-visited' : 'optin-visited' " *ngIf="companyOptInAcceptanceSummary.decisionRequired">

                    <div class="row justify-content-between align-items-center " style="width: 100%; margin-right: 0 !important; margin-left: 0 !important;">
                      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex justify-content-center justify-content-sm-end justify-content-md-end" style="padding-left: 0; padding-right: 0">
                        <label style=" margin-bottom: 0; margin-right: 10px; " [ngStyle]="{'font-weight':  companyOptInAcceptanceSummary.decision ? '' : 'bold'}">No</label>
                      </div>

                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 d-flex justify-content-center " style="padding-left: 0; padding-right: 0">
                        <p-inputSwitch (click)="onChangeToggled(companyOptInAcceptanceSummary)" [(ngModel)]="companyOptInAcceptanceSummary.decision"></p-inputSwitch>
                      </div>
                      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex justify-content-center justify-content-sm-start  justify-content-md-start" style="padding-left: 0; padding-right: 0">
                        <label style="margin-bottom: 0; margin-left: 10px ;margin-right: 5px" [ngStyle]="{'font-weight':  companyOptInAcceptanceSummary.decision ? 'bold' : ''}">Yes</label>
                      </div>
                    </div>
                  </div>
                </div>
            </ul>
          </div>
        </div>
      </p-card>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" pButton
            class="relative waves-light eca-btn eca-btn-primary"
            (click)="signOut()">
      <span>Log Out</span>  <fa-icon style="margin-left: 10px" [icon]="'sign-out'" size="lg"></fa-icon>
    </button>
    <button type="button" pButton
            class="relative waves-light eca-btn eca-btn-primary"
            (click)="recordOptInActions()">
      <span>{{modalDetails?.continueButtonText}}</span>  <fa-icon style="margin-left: 10px" [icon]="'arrow-right'" size="lg"></fa-icon>
    </button>
  </div>
</div>
